module.exports = __webpack_public_path__ + "static/pausedtracking-64b31a04e5769d9fe09130f93d8cabaf.png";